import { getActiveSubscription } from '@/data/session/session-globals';
import router from '@/vue-router/router';
import get from 'lodash/get';
import { initPerfume } from 'perfume.js';

export function setupPerfume () {
    initPerfume({
        analyticsTracker: onPerfumeEvent,
    });
}

export const queuedPerformanceEvents = [];

export function onPerfumeEvent (options) {
    const { metricName, data: duration, rating: vitalsScore } = options;
    if (duration === 0) return;
    switch (metricName) {
        case 'CLS':
            queuedPerformanceEvents.push(['perfume__cumulativeLayoutShift', duration, vitalsScore]);
            break;
        case 'FCP':
            queuedPerformanceEvents.push(['perfume__firstContentfulPaint', duration, vitalsScore]);
            break;
        case 'FID':
            queuedPerformanceEvents.push(['perfume__firstInputDelay', duration, vitalsScore]);
            break;
        case 'INP':
            queuedPerformanceEvents.push(['perfume__interactionToNextPaint', duration, vitalsScore]);
            break;
        case 'LCP':
            queuedPerformanceEvents.push(['perfume__largestContentfulPaint', duration, vitalsScore]);
            break;
        case 'TBT':
            queuedPerformanceEvents.push(['perfume__totalBlockingTime', duration, vitalsScore]);
            break;
    }

    sendQueuedPerformanceEvents();
}

export function sendQueuedPerformanceEvents () {
    const track = get(window.pendo, 'track');
    const { path } = router.currentRoute.value;
    const subId = getActiveSubscription()?.id;

    if (!track || !path || !subId) {
        return;
    }

    const { productArea, subProductArea } = router.currentRoute.value.meta || {};
    const urlPath = path;
    while (queuedPerformanceEvents.length > 0) {
        const [name, duration, vitalsScore] = queuedPerformanceEvents.pop();
        const props = {
            duration,
            vitalsScore,
            type: '__pendo__performance',
            path,
            urlPath,
            productArea,
            subProductArea,
            subId,
        };
        window.pendo.track(name, props);
    }
}
